import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import EnglishHeader from "./Components/Header/EnglishHeader";
import EnglishFooter from "./Components/Footer/EnglishFooter";
import ArabicFooter from "./Components/Footer/ArabicFooter";
import EnglishFooterMobile from "./Components/Footer/EnglishFooterMobile";
import ArabicFooterMobile from "./Components/Footer/ArabicFooterMobile";
import Home from "./Pages/Home/Index";
import PrivacyPolicyEn from "./Pages/PrivacyPolicy/PrivacyPolicy";
import ScrollToTop from "./Components/Scrollup/ScrollUp";
import HomeBG from "./Assets/Videos/HomeBG.mp4";

const routes = [
  { path: "/", enComponent: <Home />, arComponent: <Home /> },
  { path: "/PrivacyPolicy", enComponent: <PrivacyPolicyEn />, arComponent: <PrivacyPolicyEn /> },
];

export default function LanguageRoutes() {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const FooterComponent = isSmallScreen ? (isArabic ? ArabicFooterMobile : EnglishFooterMobile) : isArabic ? ArabicFooter : EnglishFooter;

  // Here timer for loading video
  useEffect(() => {
    const videoElement = document.getElementById("loader-video");

    const handleVideoPlay = () => {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 2600);
      return () => clearTimeout(timer);
    };

    if (videoElement) {
      videoElement.addEventListener("playing", handleVideoPlay);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("playing", handleVideoPlay);
      }
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="loader-overlay">
          <video id="loader-video" src={HomeBG} autoPlay muted playsInline className="loader-video" />
        </div>
      ) : (
        <div>
          <ScrollToTop />
          <EnglishHeader />
          <Routes>
            {routes.map(({ path, enComponent, arComponent }, index) => (
              <Route key={index} path={path} element={isArabic ? arComponent : enComponent} />
            ))}
            {routes.map(({ path, arComponent }, index) => (
              <Route key={index} path={`${path}/ar`} element={arComponent} />
            ))}
          </Routes>
          <FooterComponent />
        </div>
      )}
    </>
  );
}
